<template>
	<page>
		<module :title="id ? '编辑经销商角色' : '新建经销商角色'">
			<c-form ref="form">
				<c-form-item type="hidden" label="商家类型" name="stationed_type" value="2"></c-form-item>
				<c-form-item type="input" label="经销商角色名称" name="auth_name" required></c-form-item>
				<c-form-item type="hidden" label="发布商品审核" name="is_product_check" value="1"></c-form-item>
				<c-form-item type="hidden" label="运营模式" name="operation_mode" value="2"></c-form-item>
				<c-form-item type="hidden" label="结算账户类型" name="settlement_account_type" value="2"></c-form-item>
				<c-form-item type="hidden" label="是否开通店铺" name="is_open_shop" value="2"></c-form-item>
				<c-form-item type="hidden" label="平台盈利模式" name="platform_profit_model" value="1"></c-form-item>
				<c-form-item label="权限配置" >
					<power-tree :power-list="powerList"></power-tree>
				</c-form-item>
				<c-form-item type="textarea" label="备注" name="remark"></c-form-item>
			</c-form>
			
			<template slot="button">
				<c-button size="m" @click="submit">提交保存</c-button>
			</template>
		</module>
	</page>
</template>

<script>
	function renderPower(h, list, parent) {
		var arr = [], last = !list.find(item => item.children.length);
		list.map(item => {
			item.parent = parent;
			
			arr = arr.concat([
				<div class="power-item" style={`float: ${last ? 'left' : 'none'}`}>
					<c-checkbox checked={item.chk != 0} on-click={$event => this.checkHandle(item, $event)}>{item.name}</c-checkbox>
					{
						item.children.length ? [
							<div class="power-list">
								{
									renderPower.call(this, h, item.children, item)
								}
							</div>
						] : []
					}
				</div>
			]);
		});
		
		return arr;
	}
	
	const powerTree = {
		render(h) {
			return (
				<div class="power">
					{
						renderPower.call(this, h, this.powerList)
					}
				</div>
			)
		},
		
		props: {
			powerList: Array
		},
		
		methods: {
			checkHandle(power, state) {
				state = state ? 1 : 0;
				
				power.chk = state;
				!function poll(list) {
					list.forEach(item => {
						item.chk = state;
						poll(item.children);
					});
				}(power.children);
				
				!function poll(parent) {
					if (parent) {
						parent.chk = parent.children.find(item => !!item.chk) ? 1 : 0;
						poll(parent.parent);
					}
				}(power.parent);
			}
		}
	};
	
	export default {
		name: 'seller_auth_edit',
		
		components: {
			powerTree
		},
		
		props: {
			id: String
		},
		
		data() {
			return {
				is_firest: true,
				powerList: []
			}
		},
		
		watch: {
			id() {
				this.update();
			}
		},
		
		mounted() {
			this.update();
		},
		
		methods: {
			update() {
				this.request({
					url: '/stationed/auth/detail',
					data: {
						auth_id: this.id || 0
					},
					success: data => {
						if (this.id) {
							this.$refs.form.set(data.info);
						}
						this.powerList = data.auth_menu;
					}
				});
			},
			
			submit() {
				this.$refs.form.submit({
					url: this.id ? '/stationed/auth/edit' : '/stationed/auth/add',
					rule: {
						auth_name: '请填写经销商角色名称'
					},
					dataFormatter: data => {
						data.auth_id = this.id;
						data.auth_menus = [];
						!function poll(list) {
							list.forEach(item => {
								if (item.chk) {
									data.auth_menus.push({
										menu_id: item.id
									});
								}
								poll(item.children);
							});
						}(this.powerList);
						return data;
					},
					success:(data,res) => {
						this.$message({
							text: '保存成功'
						});
						this.$bus.$emit('sellerAuthList.update', this.id ? undefined : 1);
						this.redirectTo('/seller_auth_list');
					},
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	>>> .power {
		max-height: 500px;
		border: 1px solid #ddd;
		overflow: auto;
			
		&-list {
			margin-left: 40px;
			overflow: hidden;
		}
		
		> &-item {
			margin-left: 20px;
			
			&:nth-last-child(1) {
				margin-bottom: 15px;
			}
		}
		
		&-item {
			margin-top: 15px;
			margin-right: 20px;
		}
	}
</style>